// extracted by mini-css-extract-plugin
export default {"root":"a8Jsuc","shadow":"GA14Sz","leftTop":"jcCIEI","rightTop":"SmmWva","centerTop":"GRLaH4","bg":"qkaSM5"};